import { Zap, Heart, Clock, Shield, Snowflake, Star, Crosshair } from 'lucide-react';

interface StartScreenProps {
  onStartGame: () => void;
}

const StartScreen = ({ onStartGame }: StartScreenProps) => {
  return (
    <div className="flex flex-col items-center justify-center text-center max-w-2xl px-8">
      <img
        src="/logo.png"
        alt="Zombie Slayer"
        className="mb-6 max-w-md w-full h-auto animate-pulse"
      />
      <div className="mb-8 space-y-4 text-lg text-gray-300">
        <p className="text-2xl text-yellow-400 font-bold">Survive the Zombie Apocalypse!</p>
        <p>Use <span className="text-green-400 font-bold">WASD</span> to move your character</p>
        <p>Use <span className="text-red-400 font-bold">F Key</span> to attack zombies</p>
        <p>Use <span className="text-blue-400 font-bold">1/2/3/4/5 Keys</span> to switch weapons</p>
        <p>Collect <span className="text-purple-400 font-bold">Power-ups</span> from defeated zombies</p>
        <p>Unlock weapons: <span className="text-orange-400 font-bold">Gun at 500</span> | <span className="text-orange-400 font-bold">Axe at 1000</span> | <span className="text-red-400 font-bold">Laser at 2000</span> | <span className="text-orange-500 font-bold">Grenade at 5000</span> points!</p>
      </div>
      <div className="mb-8 grid grid-cols-2 gap-4 text-sm">
        <div className="bg-gray-800 p-4 rounded-lg">
          <h3 className="text-yellow-400 font-bold mb-2">Power-ups:</h3>
          <div className="space-y-1 text-xs">
            <div className="flex items-center gap-2"><Zap className="w-3 h-3 text-yellow-400" /> Speed Boost</div>
            <div className="flex items-center gap-2"><Heart className="w-3 h-3 text-red-500" /> Health Restore</div>
            <div className="flex items-center gap-2"><Clock className="w-3 h-3 text-blue-400" /> Slow Zombies</div>
            <div className="flex items-center gap-2"><Shield className="w-3 h-3 text-purple-400" /> Double Damage</div>
            <div className="flex items-center gap-2"><Shield className="w-3 h-3 text-cyan-400" /> Shield</div>
            <div className="flex items-center gap-2"><Crosshair className="w-3 h-3 text-orange-400" /> Rapid Fire</div>
            <div className="flex items-center gap-2"><Snowflake className="w-3 h-3 text-blue-200" /> Freeze Zombies</div>
            <div className="flex items-center gap-2"><Star className="w-3 h-3 text-yellow-300" /> Score Multiplier</div>
          </div>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg">
          <h3 className="text-red-400 font-bold mb-2">Survival Tips:</h3>
          <div className="space-y-1 text-left text-xs">
            <p>• Keep moving to avoid zombies</p>
            <p>• Sword: Close combat</p>
            <p>• Gun: Ranged attacks</p>
            <p>• Axe: Spin attack (large area)</p>
            <p>• Laser: Hold F for beam</p>
            <p>• Grenade: F to launch explosive</p>
            <p>• Collect power-ups strategically</p>
            <p>• Switch weapons with 1/2/3/4/5</p>
          </div>
        </div>
      </div>
      <button
        onClick={onStartGame}
        className="px-12 py-4 bg-red-600 hover:bg-red-500 text-white text-2xl font-bold rounded-lg transition-colors transform hover:scale-105 animate-bounce">
        START GAME
      </button>
    </div>
  );
};

export default StartScreen;
